module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/block-capacity-list/block-capacity-list.component.scss
// module id = ./src/app/modules/common-module/components/block-capacity-list/block-capacity-list.component.scss
// module chunks = 9